import type { ColunaKanban, Pedido, StatusBackend } from './types';

/**
 * Mapeia status do backend para coluna do Kanban.
 *
 * Backend: recebido | pago | em_separacao | em_rota | entregue | cancelado
 * Kanban : aguardando_pagamento | pago | aguardando_separacao
 *
 * Pedidos em em_rota / entregue / cancelado ficam fora do board principal.
 */
export function colunaDePedido(p: Pedido): ColunaKanban | null {
  if (p.status === 'recebido') return 'aguardando_pagamento';
  if (p.status === 'pago') return 'pago';
  if (p.status === 'em_separacao') return 'aguardando_separacao';
  return null;
}

export function statusDeColuna(coluna: ColunaKanban): StatusBackend {
  if (coluna === 'aguardando_pagamento') return 'recebido';
  if (coluna === 'pago') return 'pago';
  return 'em_separacao';
}

export interface ColunaSpec {
  id: ColunaKanban;
  titulo: string;
  acento: 'amber' | 'moss' | 'sage';
}

export const COLUNAS: ColunaSpec[] = [
  { id: 'aguardando_pagamento', titulo: 'Pedido novo', acento: 'amber' },
  { id: 'pago', titulo: 'Aguardando pagamento', acento: 'moss' },
  { id: 'aguardando_separacao', titulo: 'Em separação', acento: 'sage' },
];

// Semântica de pagamento + rótulos de status, compartilhados por telas que
// agregam por status (ex.: Clientes). Pago = qualquer estado a partir de 'pago'.
export const STATUS_PAGO: StatusBackend[] = ['pago', 'em_separacao', 'em_rota', 'entregue'];

export function isPago(s: StatusBackend): boolean {
  return STATUS_PAGO.includes(s);
}

export const STATUS_LABEL: Record<StatusBackend, string> = {
  recebido: 'Pedido novo',
  pago: 'Aguardando pagamento',
  em_separacao: 'Em separação',
  em_rota: 'Em rota',
  entregue: 'Entregue',
  cancelado: 'Cancelado',
};
